import { Http } from './../helpers'
import { async } from 'q'
import { Config, API } from '../config'

export const InformfixService = {
  async search(params) {
    return await Http.get('/informfix', { params: params })
  },
  async listPending(params) {
    return await Http.get('/informfix/list-pending', { params: params })
  },
  // ใบแจ้งซ่อมที่ยังไม่มีได้มีการนัดหมาย
  async listNew(params) {
    return await Http.get('/informfix/list-new', { params: params })
  },
  async view(id) {
    return await Http.get('/informfix/' + id)
  },
  async countWorkstatus() {
    return await Http.get('/informfix/count-workstatus')
  },
  async countPostpone() {
    return await Http.get('/informfix/count-postpone')
  },
  async count4task() {
    return await Http.get('/informfix/count4task')
  },
  async countNewInform() {
    return await Http.get('/informfix/count-new-inform')
  },
  async countProcess() {
    return await Http.get('/informfix/count-process')
  },
  async getJobs(id) {
    return await Http.get('/informfix/' + id + '/jobs')
  },
  async create(params) {
    return await Http.post('/informfix', params)
  },
  async getImages(id) {
    return await Http.get('/informfix/' + id + '/images')
  },
  async deleteImage(id, imageId) {
    return await Http.delete(
      '/informfix/' + id + '/images/' + imageId + '/delete',
    )
  },
  async update(id, params) {
    return await Http.put('/informfix/' + id, params)
  },
  async delete(id) {
    return await Http.delete('/informfix/' + id)
  },
  /**
   * ปิดงานใบแจ้งซ่อมและคิวงาน
   * ระบบจะเปลี่ยนสถานะใบแจ้งซ่อมเป็นเสร็จแล้วและคิวงานทั้งหมดเป็นเสร็จแล้วด้วย
   * @param {*} id
   * @param {*} params
   */
  async close(id) {
    return await Http.put('/informfix/' + id + '/close')
  },
  async cancel(id, form) {
    return await Http.put('/informfix/' + id + '/cancel', {
      canceled_remark: form.canceled_remark,
      id: id,
    })
  },
  /**
   * ส่งไปแจ้งซ่อมไปจัดคิว
   * @param {*} id
   */
  async send2task(id) {
    return await Http.put('/informfix/' + id + '/send2task')
  },
  /**
   * สถานะทั้งหมด
   */
  async getWorkStatus() {
    return await Http.get('/informfix/workstatus')
  },
  /**
   * ยืนยันคิวงานที่ใบแจ้งซ่อมระบบจะเปลี่ยนสถานะเป็น [ยืนยันแล้ว] คิวงานจะถูกเปลี่ยนเป็น [มอบหมายงานแล้ว]
   */
  async comfirmInform(id) {
    return await Http.put('/informfix/' + id + '/confirm-inform')
  },
  /**
   * ยืนยันคิวงานที่ใบแจ้งซ่อมระบบจะเปลี่ยนสถานะเป็น [อยู่ระหว่างดำเนินการ] คิวงานจะถูกเปลี่ยนเป็น [อยู่ระหว่างดำเนินการ]
   */
  async comfirmJob(id) {
    return await Http.put('/informfix/' + id + '/confirm-job')
  },
  /**
   * เมื่อจัดคิวงานอีกครั้ง เนื่องจากมีการเลื่อนนัด
   * ใบแจ้งซ่อมจะเป็น[รอยืนยันลูกค้า] คิวงานจะถูกเปลี่ยนเป็น[open]เหมือนเดิม
   */
  async confirmTask(id) {
    return await Http.put('/informfix/' + id + '/confirm-task')
  },
  /**
   * เมื่อจัดคิวงานอีกครั้ง เนื่องจากมีการเลื่อนนัด
   * ใบแจ้งซ่อมจะเป็น[รอยืนยันลูกค้า] คิวงานจะถูกเปลี่ยนเป็น[open]เหมือนเดิม
   */
  async reconfirmTask(id) {
    return await Http.put('/informfix/' + id + '/reconfirm-task')
  },
  /**
   * เปลี่ยนสถานะได้ทุกสถานะ
   */
  async setWorkStatus(id, params) {
    return await Http.put('/informfix/' + id + '/workstatus', params)
  },
  async upload(id, data) {
    return await Http.post('/informfix/' + id + '/upload', data, {
      'Content-Type': 'multipart/form-data',
    })
  },
  async getGallery(id) {
    let photos = []
    this.getImages(id).then((rs) => {
      if (rs) {
        rs.data['data'].forEach((photo, index) => {
          photos.push({
            original: photo.url,
            thumbnail: photo.thumbnail,
            description: photo.description,
            size: photo.size,
            extension: photo.extension,
            url: photo.url,
            height: 1,
            width: 1,
            image: photo.url,
          })
        })
      }
    })
    return photos
  },
  async getInformGroup() {
    return await Http.get('/informfix/group')
  },
  async setImgDescription(id, params) {
    return await Http.put('/informfix/img-description/' + id, params)
  },
  async assignJob(id, params) {
    return await Http.post('/informfix/' + id + '/assign-job', params)
  },
  async printWord(id, url) {
    return await Http.get(
      API.rootUrl + '/backend/web/fix/inform-fix/word?id=' + id,
      {
        params: {},
        responseType: 'blob',
      },
    )
  },
  async downloadDoc(url) {
    return await Http.get(
     url,
      {
        params: {},
        responseType: 'blob',
      },
    )
  },
}
